import XSTAKING from './XStakingABI.json';
import XENDToken from './XendTokenABI.json';

const abiManager = {
	XSTAKING,
	XENDToken
}


export default abiManager;